import {Component, OnInit, ChangeDetectorRef} from '@angular/core';

import {Router} from '@angular/router';

import {HttpService} from './services/HttpService';

import {FacebookService, LoginResponse, LoginOptions, UIResponse, UIParams, FBVideoComponent} from 'ngx-facebook';


declare global {
    interface Window {
        fbAsyncInit: any;
    }
}

@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html',
    providers: [HttpService]
})


export class AppComponent implements OnInit {
    public loading: boolean = false;
    public task: any;
    public User_Details: any;


    constructor(
        public router: Router,
        public http: HttpService,
        private cdref: ChangeDetectorRef,
        private fb: FacebookService
    ) {
        window.fbAsyncInit = function () {
            console.log('fbAsyncInit called');
            //  <---- THIS RIGHT HERE TRIGGERS A CUSTOM EVENT CALLED 'fbload'
            fb.init({
                appId: '435410636872931',
                version: 'v2.9'
            });
            console.log('init called');


        };


    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();

    }

    ngOnInit() {
        console.log(this.router.url);
        if (localStorage.getItem('Admin_User_Details')) {
            this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
            // if (this.User_Details.role.id == 1) {
            // 	this.router.navigate(['/users']);
            // }
            // else {
            // 	this.router.navigate(['/brandsuggestions']);
            // }
        } else {
            console.log('go to the login page');
            setTimeout(() => {
                console.log(this.router.routerState.snapshot.url);
                if (this.router.routerState.snapshot.url.indexOf('/password_reset') < 0) {
                    this.router.navigate(['/pages/login']);
                }
            }, 1000)
        }

        this.task = setInterval((function () {
            if (this.router.routerState.snapshot.url != '/pages/login' && this.router.routerState.snapshot.url.indexOf('/password_reset') < 0) {
                this.checkUserToken();
            }

        }).bind(this), 60000);
    }

    checkUserToken() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.http.makeRequestPost(['app/user/checktoken', {token: this.User_Details.token}])
        .subscribe(
            (response) => {
                if (response.data) {
                    if (response.data.length == 0) {
                        this.logOutUser();
                    }
                }
                if (response.error) {

                }
            },
            (error) => {

            }
        )
    }

    logOutUser() {
        console.log(this.router);
        localStorage.removeItem('Admin_User_Details');
        this.router.navigate(['/pages/login']);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts